/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_SAL_SUMMARY_ITEM = {
  id: 'sales_summary',
  screenId: 'met-sal-summary',
  label: 'Resumen',
  description: 'Totales de ventas, ticket promedio y gráficos del período.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Vista general de ventas facturadas: importes, cantidad de comprobantes, ticket promedio y distribución por tipo de comprobante o moneda.',
      },
      {
        title: 'Paso 1 — Elegir período',
        bullets: [
          'Atajos: Hoy, Semana, Mes, Mes anterior o Personalizado (desde / hasta + Aplicar).',
          '«Unificar monedas» — convierte todo a ARS para un total único; desmarcá para ver por moneda.',
        ],
      },
      {
        title: 'Paso 2 — Leer indicadores',
        bullets: [
          'Totales de ventas y cantidad de comprobantes.',
          'Gráficos de torta y barras según los datos del período.',
          'Artículos más facturados y artículos con más descuentos (ranking por importe).',
          'Para ranking completo de productos vendidos o márgenes, usá Métricas → Productos.',
          'Botón «Imprimir» abajo en la pantalla de métricas (imprime el informe visible).',
        ],
      },
    ],
  },
}
